import React, {useRef} from "react";
import FlatButton from "./flat_button";
import {ReactComponent as Cloud} from '../../assets/svgs/cloud_icon.svg';
import {useDetectionState} from "../../core/state/detection/detection_context";
import {uploading} from "../../core/state/detection/detection_actions";
import {DETECT_PAGE} from "../../config/router/router";
import {useHistory} from "react-router-dom/cjs/react-router-dom";

function FileFlatButton() {

    const {dispatch} = useDetectionState()
    const inputFile = useRef(null)
    const history = useHistory();


    const onFileChanged = (e) => {
        const src = URL.createObjectURL(e.target.files[0]);

        const pathname = window.location.pathname
        if (pathname !== DETECT_PAGE){
            history.push(DETECT_PAGE)
        }

        dispatch(uploading(e.target.files[0], src))
    }

    const onButtonClick = () => {
        inputFile.current.click();
    };

    return (
        <label className={"flex flex-col items-center"}>
            <FlatButton name={"Upload content"} icon={<Cloud/>} onClick={onButtonClick}/>
            <input required accept={"image/jpeg, image/png, video/mp4"} onChange={onFileChanged} type={"file"}
                   id="collage" className={"hidden"} ref={inputFile}/>
        </label>
    );
}

export default FileFlatButton;